<template>
    <div>
        <v-dialog v-model="cbIsOpen" :max-width="maxWidth" :persistent="persistent">
            <v-card class="rounded-md">
                <slot v-if="customText">

                </slot>
                <v-card-title v-else>
                    <h4 class="mx-auto">Are you sure ?</h4>
                </v-card-title>
                <v-card-actions class="d-flex justify-center">
                    <v-btn small @click="emitSelected(false)" color="error">{{ noBtnText }}</v-btn>
                    <v-btn small @click="emitSelected(true)" color="success">{{ yesBtnText }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data:()=>({
        cbIsOpen:false
    }),
    props:{
        noBtnText:{
            type:String,
            default:"No"
        },
        yesBtnText:{
            type:String,
            default:"Yes"
        },
        customText:{
            type:Boolean,
            default:false
        },
        maxWidth:{
            type:String,
            default:"300px"
        },
        persistent:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        open(){
            this.cbIsOpen= true;
        },
        close(){
            this.cbIsOpen= false;
        },
        emitSelected(val){
            this.$emit("confirm",val);
            if(!val){
                this.close();
            } 
        }
    }
}
</script>